import request from '@/utils/request'

export function add(data) {
  return request({
    url: 'api/guarantee',
    method: 'post',
    data
  })
}

export function del(ids) {
  return request({
    url: 'api/guarantee/',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'api/guarantee',
    method: 'post',
    data
  })
}

export function getSelectList(params) {
  return request({
    url: 'api/guarantee/company/fuzzySearchByName',
    method: 'get',
    params
  })
}

export function getSelectListInfo(params) {
  return request({
    url: 'api/guarantee/company/baseInfo',
    method: 'get',
    params
  })
}




export default { add, edit, del,getSelectList ,getSelectListInfo}
